import { getLocalStorage } from "@jti/rest-api";
import type { CheckoutGTMFlowType } from "@jti/tracker";

type CheckoutFlowByOrder = Record<string, { checkoutFlow: CheckoutGTMFlowType }>;

const STORAGE_KEY = "checkoutFlowByOrder";

// Storage can be blocked or corrupted; tracking must never break checkout.
const readCheckoutFlowByOrder = (): CheckoutFlowByOrder => {
  try {
    return getLocalStorage().get<CheckoutFlowByOrder>(STORAGE_KEY, {});
  } catch {
    return {};
  }
};

const writeCheckoutFlowByOrder = (checkoutFlowByOrder: CheckoutFlowByOrder): void => {
  try {
    getLocalStorage().set(STORAGE_KEY, checkoutFlowByOrder);
  } catch {
    // Tracking data is optional.
  }
};

export const saveOrderCheckoutFlow = (orderNumber: string, checkoutFlow: CheckoutGTMFlowType): void => {
  const checkoutFlowByOrder = readCheckoutFlowByOrder();

  if (checkoutFlowByOrder[orderNumber]) {
    return;
  }

  writeCheckoutFlowByOrder({ ...checkoutFlowByOrder, [orderNumber]: { checkoutFlow } });
};

export const getOrderCheckoutFlow = (orderNumber: string): CheckoutGTMFlowType | undefined =>
  readCheckoutFlowByOrder()[orderNumber]?.checkoutFlow;

export const removeOrderCheckoutFlow = (orderNumber: string): void => {
  const checkoutFlowByOrder = readCheckoutFlowByOrder();

  delete checkoutFlowByOrder[orderNumber];
  writeCheckoutFlowByOrder(checkoutFlowByOrder);
};
